var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { setColor } from '../icon.utilities';
export function SAIconFilter(_a) {
    var size = _a.size, colorVariant = _a.colorVariant, onClick = _a.onClick, icon = _a.icon, theme = _a.theme, additionalProps = __rest(_a, ["size", "colorVariant", "onClick", "icon", "theme"]);
    var iconTheme = useContext(ThemeContext);
    var color = setColor(iconTheme, colorVariant, 'primary');
    var renderSize = size !== null && size !== void 0 ? size : '100px';
    return (React.createElement("svg", __assign({}, additionalProps, { width: renderSize, height: renderSize, viewBox: "0 0 100 100", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }),
        React.createElement("g", { transform: "scale(4 4)" },
            React.createElement("path", { d: "M0.104005 0.555949C0.272764 0.215428 0.619962 0 1.00001 0H19C19.3801 0 19.7272 0.215428 19.896 0.555949C20.0648 0.89647 20.0259 1.30322 19.7957 1.60564L12.8 10.7973V19C12.8 19.3543 12.6125 19.6822 12.3071 19.8619C12.0018 20.0416 11.6241 20.0462 11.3144 19.8742L7.71436 17.8742C7.3969 17.6978 7.20001 17.3632 7.20001 17V10.7973L0.204266 1.60564C-0.0259036 1.30322 -0.0647544 0.89647 0.104005 0.555949ZM3.0178 2L8.99575 9.85436C9.12825 10.0285 9.20001 10.2412 9.20001 10.46V16.4116L10.8 17.3005V10.46C10.8 10.2412 10.8718 10.0285 11.0043 9.85436L16.9822 2H3.0178Z", fill: color }))));
}
//# sourceMappingURL=icon.filter.component.js.map